import { render, staticRenderFns } from "./DocumentTemplatePdfComponent.vue?vue&type=template&id=2cfc85e7"
import script from "./DocumentTemplatePdfComponent.vue?vue&type=script&lang=js"
export * from "./DocumentTemplatePdfComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports